import Axios from 'helpers/http'

const status = new Axios()

import OrbitApiV1 from '../orbitV1'

class StatusAPI {
  /**
   * to get the system status of Stripe
   * @returns
   */
  static getStripeStatus() {
    return status.httpGet(
      `https://status.stripe.com/current/full`,
      {},
      true,
      {},
      false
    )
  }

  /**
   * to get the status of Payment Services
   * @returns
   */
  static getPaymentStatus() {
    return OrbitApiV1.httpGet(
      `faber/status/grafana-status/`,
      {},
      false,
      {},
      false
    )
  }
}

export default StatusAPI
